import get from 'lodash.get';

const getUser = (userState) => {
  const email = get(userState, 'user.email', '');
  const isWizeliner = email.endsWith('wizeline.com');
  const isInitialized = get(userState, 'user.role', false);
  return {
    ...userState.user,
    isWizeliner,
    isInitialized: !!isInitialized,
  };
};

export default {
  getUser,
};



// WEBPACK FOOTER //
// ./store/modules/user/getters.js